export const SET_INGREDIENTS = "ingredient/MR_SET_INGREDIENTS"
export const SET_SETS = "sets/MR_SET_SETS"
export const SET_PRODUCTS = "product/MR_SET_PRODUCTS"
export const SET_IS_LOADING = "MR_SET_IS_LOADING"
export const SET_MENU_SEARCH = "MR_SET_MENU_SEARCH"
export const SET_MENU_CATEGORY = "MR_SET_MENU_CATEGORY"
export const SET_MENU_PAGE = "MR_SET_MENU_PAGE"
export const SET_SELECTED_CATEGORY = "MR_SET_SELECTED_CATEGORY"
export const SET_UNIQUE_CATEGORIES = "MR_SET_UNIQUE_CATEGORIES"
